<template>
<div class="news-detail">
    <publicHead :background="bg" title="新闻中心" en-title="NEWS CENTER" @check="check" :list="['企业新闻','技术动态']" :active="detail.now.type==1?0:1" />
    <div class="wrap">
        <p class="title">{{detail.now.name}}</p>
        <p class="date">发布时间：{{detail.now.date}}</p>
        <p class="rich" v-html="detail.now.content"></p>
        <div class="next">
            <router-link tag="div" :to="{path:'/news-detail',query:{id:detail.previous.id}}" v-if="detail.previous.name">上一篇：{{detail.previous.name }}</router-link>
            <div v-else>上一篇：无</div>
            <router-link tag="div" :to="{path:'/news-detail',query:{id:detail.next.id}}" v-if="detail.next.name">下一篇：{{detail.next.name }}</router-link>
            <div v-else>下一篇：无</div>
        </div>
    </div>
</div>
</template>

<script>
import {
    article_view
} from "../assets/js/api";
export default {
    data() {
        return {
            detail: {},
            bg: require("../assets/img/news-head.png"),
        };
    },
    watch: {
        "$route.query.id": {
            handler(e) {
                article_view({
                    id: this.$route.query.id,
                }).then((r) => {
                    this.detail = r.data;
                });
            },
            deep: true,
        },
    },
    created() {
        article_view({
            id: this.$route.query.id,
        }).then((r) => {
            this.detail = r.data;
        });
    },
    methods: {
        check(e) {
            if (e == 0) {
                this.$router.push({
                    path: "/news",
                    query: {
                        type: 0,
                    },
                });
            } else {
                this.$router.push({
                    path: "/news",
                    query: {
                        type: 1,
                    },
                });
            }
        },
    }
};
</script>

<style lang="less" scoped>
.news-detail {
    background: rgb(246, 246, 246);

    .wrap {
        margin-top: 1.05rem;
        padding: 0.5rem 0.3rem;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(29, 62, 85, 0.14);

        .title {
            font-size: 0.3rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            margin-bottom: 0.37rem;
        }

        .date {
            font-size: 0.22rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            margin-bottom: 0.87rem;
        }

        .rich {
            margin-bottom: 0.53rem;
        }

        .next {
            line-height: 0.73rem;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cccccc;
            border-top: 1px solid #cccccc;

            div {
                width: 2rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 0.22rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
            }

            div:first-child {
                color: #126fcc;
            }
        }
    }
}
</style>
